<div class="area">
    <div class="area-draw">
        <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
        <div style="position: relative; padding-top: 10px;">
            <div class="artboard" #artboard>
            </div>
        </div>
    </div>
</div>
